import { render, staticRenderFns } from "./ExperimentBook.vue?vue&type=template&id=7dbda56e&scoped=true"
import script from "./ExperimentBook.vue?vue&type=script&lang=ts"
export * from "./ExperimentBook.vue?vue&type=script&lang=ts"
import style0 from "./ExperimentBook.vue?vue&type=style&index=0&id=7dbda56e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dbda56e",
  null
  
)

export default component.exports